import http from 'utils/http'
import Vue from 'vue'

import { SET_SETTINGS, SET_SETTINGS_PROPERTY } from 'vx/mutations'

// Settings state.
const state = {
  settings: {
    commission_rate: null,
    deposit_payment: null,
    notification_email: null,
    notification_phone: null,
    talent_invoice_template: null,
    billboard_post_length: null,
    deposit_warning_notification: null,
    final_payment_warning: null,
    final_payment_cutoff: null,
    intial_talent_reminder: null,
    second_talent_reminder: null,
    third_talent_reminder: null,
    final_talent_reminder: null,
    tnc_link: null,
    privacy_link: null,
    ios_minimum_version: null,
    android_minimum_version: null,
    app_minimum_version: null,
    completed_bookings_default_date_range: null
  }
}

// Settings state getters.
const getters = {}

// Settings actions
const actions = {
  /**
   * Get all settings.
   *
   * @return Promise
   */
  getSettings ({ commit }, id) {
    return http.get(`settings`).then(response => {
      commit(SET_SETTINGS, response.data)

      return response
    })
  },

  getBookingCustomFieldSettings ({ commit }, id) {
    return http.get(`settings/booking_custom_field`).then(response => {
      return response
    })
  },

  /**
   * Update settings.
   *
   * @return Promise
   */
  updateSettings ({ commit }, payload) {
    return http.put(`settings`, payload).then(response => {
      return response
    })
  },

  updateCustomField ({ commit }, payload) {
    return http.post(payload.endpoint, payload.data).then((response) => {
      commit(SET_SETTINGS_PROPERTY, { property: payload.attribute, value: response.data[payload.attribute] })
      return response
    })
  },

  setSettingsProperty ({ commit }, { property, value }) {
    commit(SET_SETTINGS_PROPERTY, { property, value })
  },

  /**
   * Upload a File
   *
   * @return Promise
   */
  uploadFile ({ commit }, { file, fileType }) {
    let payload = new FormData()
    payload.append('file', file)
    payload.append('file_type', fileType)

    return http.post(`settings/upload_file`, payload, {
      headers: {'Content-Type': 'multipart/form-data'},
      maxContentLength: 15000000
    })
      .then((response) => {
        commit(SET_SETTINGS_PROPERTY, { property: fileType, value: response.data[fileType] })
        return response
      })
  }
}

// Settings state mutations.
const mutations = {
  [SET_SETTINGS] (state, settings) {
    state.settings = settings
  },

  [SET_SETTINGS_PROPERTY] (state, { property, value }) {
    Vue.set(state.settings, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
